import { render, staticRenderFns } from "./DomainProductMemberPrices.vue?vue&type=template&id=3cb4063b&scoped=true&"
import script from "./DomainProductMemberPrices.vue?vue&type=script&lang=js&"
export * from "./DomainProductMemberPrices.vue?vue&type=script&lang=js&"
import style0 from "./DomainProductMemberPrices.vue?vue&type=style&index=0&id=3cb4063b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cb4063b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCheckbox,VCol,VRow,VTextField})
